const PATH = '/builder/secrets';

export const secrets = ($http: HttpApi) => ({
  get: (sheetId: string, params: HttpParams['params'] = {}) => $http.$get(`${PATH}/${sheetId}`, { params }),
  list: (params: HttpParams['params']) => $http.$get(PATH, { params }),
  create: (data: HttpParams['body']) => $http.$post(PATH, { body: data }),
  update: (sheetId: string, data: HttpParams['body'] = {}) => $http.$patch(`${PATH}/${sheetId}`, { body: data }),
  delete: (sheetId: string) => $http.$delete(`${PATH}/${sheetId}`),
});
